// src/features/wbs/editor/types-local.ts
// 목적: 화면 전용 계산 속성(_codeCalc, _levelCalc)만 확장하여 사용
// - 중앙 타입 중복/복제는 금지: 모든 도메인 필드는 src/types/wbs.ts를 import 하여 사용

// 중앙 타입 import (프로젝트 상대 경로 맞춰주세요)
import type { WbsItemVersion, WbsList } from '../types';

// 화면 전용 계산 필드가 추가된 트리 노드
export type WbsTreeNode = WbsItemVersion & {
    children: WbsTreeNode[];
    _levelCalc: number; // 화면용: 1부터 시작하는 레벨 계산
    _codeCalc: string; // 화면용: "1.2.3" 형태 코드(표시 전용)
};

// API 공용 반환 형태(백엔드가 list+items를 주는 경우)
export type WbsListWithItems = {
    list: WbsList | null;
    items: WbsItemVersion[];
};

// 변경/추가 부분만

// 프론트에서 배치 저장 시 보낼 아이템(클라이언트 → 서버)
export type SaveDraftItemInput = {
    clientId: string; // ★ 로컬 식별자(cid)
    nodeId?: string | null; // ★ 서버 노드ID (없으면 null 유지). 최초엔 대부분 null
    parentNodeId?: string | null;
    parentClientId?: string | null;
    orderIndex: number;
    name: string;
    plannedStart?: string | null;
    plannedFinish?: string | null;
    weight?: number | null;
    memo?: string | null;
    // 필요 시 추가
};

// 서버가 돌려주는 결과(서버 → 클라이언트)
export type SaveDraftItemResult = {
    clientId?: string; // ★ 서버가 패스스루하여 돌려줌
    nodeId: string; // 서버에서 확정된 nodeId
    wbsItemVersionId: string; // 생성/갱신된 버전ID
};


// 공통 ID
export type NodeId = string;               // WbsNode.id (uuid)
export type ClientId = string;
export type KeyId = NodeId | ClientId;
export type ParentKey = string | null;     // null = 루트


// 에디터에서 쓰는 Draft 아이템(서버 모델과 1:1은 아님)
export type DraftItem = {
  nodeId?: NodeId | null;
  cid?: ClientId;
  
  parentNodeId?: NodeId | null;
  parentKey?: KeyId | null;
  orderIndex?: number | null;

  name: string;
  code?: string | null;   // 서버 계산 필드
  level?: number | null;  // 서버 계산 필드
  plannedStart?: string | null;
  plannedFinish?: string | null;
  durationDays?: number | null;
  weight?: string | number | null;
  memo?: string | null;
  assignee?: string | null;

  isDeleted?: boolean | null;

  publishedListVersion?: number | null;
};

// 리스트/테이블 렌더용 평탄화 행(필요 시)
// export type FlatRow = {
//     nodeId: NodeId | null;
//     cid?: ClientId;

//     parentNodeId: NodeId | null;
//     parentKey?: KeyId | null;
//     orderIndex?: number | null;
//     depth: number;
    
//     name: string;
//     code?: string | null;
//     level?: number | null;
    
//     plannedStart?: string | null;
//     plannedFinish?: string | null;
//     weight?: number | null;
//     memo?: string | null;
//     assignee?: string | null;
// };

export type FlatRow = DraftItem & {
    depth: number;
    hasChildren?: boolean;
    publishedListVersion?: number | null;
    isDeleted?: boolean;
    cid?: string;
}

export type DraftChange = {
  kind: 'content' | 'order';
  nodeId: KeyId;                  // nodeId 또는 cid
  label: string;                  // UI에 보여줄 제목
  prev?: Record<string, unknown>; // 이전 값(필드->값)
  next?: Record<string, unknown>; // 이후 값(필드->값)
};

// 부모별 정렬 스냅샷(“정렬 저장” dirty 비교에 사용)
export type OrderMap = Map<ParentKey, KeyId[]>;

// nodeId 또는 cid 중 하나는 반드시 있어야 한다는 전제
export function keyOf(o: { nodeId?: string | null; cid?: string }): KeyId {
    if (o.nodeId && o.nodeId.length > 0) return o.nodeId;
    if (o.cid && o.cid.length > 0) return o.cid;
    // 여기까지 오면 둘 다 없음 → 개발자 실수 케이스
    throw new Error('keyOf: both nodeId and cid are missing');
}



// DEPRECATED - v2 타입으로 이동하세요
export * from '../types';
